import { forwardRef } from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { scrollbarClasses } from './classes';
import type { ScrollbarProps } from './types';

// ----------------------------------------------------------------------

const ScrollRoot = styled(Box)(({ theme }) => ({
  minWidth: 0,
  minHeight: 0,
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch',
  /* Hide scrollbar while keeping scroll functionality */
  scrollbarWidth: 'none', // Firefox
  msOverflowStyle: 'none', // IE and Edge
  '&::-webkit-scrollbar': {
    display: 'none', // Chrome, Safari, Opera
  },
}));

export const Scrollbar = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ slotProps, children, fillContent, sx, ...other }, ref) => (
    <ScrollRoot ref={ref} className={scrollbarClasses.root} sx={sx} {...other}>
      <Box sx={slotProps?.wrapper}>
        <Box
          sx={{
            ...(fillContent && {
              minHeight: 1,
              display: 'flex',
              flex: '1 1 auto',
              flexDirection: 'column',
            }),
            ...slotProps?.contentWrapper,
          }}
        >
          <Box sx={slotProps?.content as any}>{children}</Box>
        </Box>
      </Box>
    </ScrollRoot>
  )
);

Scrollbar.displayName = 'Scrollbar';
